export const dictionary = {
  es: {
    navigation: {
      home: "Inicio",
      aboutUs: "Quiénes Somos",
      services: "Servicios",
      developmentalConditions: "Condiciones del Desarrollo",
      ourTests: "Nuestras Pruebas",
      testimonials: "Testimonios",
      resources: "Recursos",
      contact: "Contacto"
    },
    common: {
      scheduleAppointment: "Agenda una Cita",
      loading: "Cargando…",
      back: "Volver",
      home: "Inicio",
      seeMore: "Ver más",
      readMore: "Leer más",
      contactUs: "Contáctanos",
      learnMore: "Conoce más",
      viewProfile: "Ver Perfil",
      scheduleConsultation: "Agendar Consulta",
      scheduleEvaluation: "Agendar Evaluación",
      viewAllServices: "Ver Todos los Servicios",
      viewAllSpecialists: "Ver Todos los Especialistas",
      viewRelatedServices: "Ver servicios relacionados"
    },
    header: {
      scheduleAppointment: "Agenda una Cita",
      contactInfo: {
        schedule: "Lun 1-6pm, Mar-Vie 9am-6pm, Sáb 8am-1pm",
        phone: "+506 8583-8056",
        phoneLabel: "Llamar al teléfono principal",
        email: "info@neuropequescr.com",
        emailLabel: "Enviar correo electrónico",
        contactPageLabel: "Ir a la página de contacto para agendar una cita"
      },
      logo: {
        label: "Ir a la página principal de Neuro Peques - Centro de Especialidades para el abordaje del Neurodesarrollo Infantil",
        alt: "Neuro Peques - Logo del Centro de Especialidades para el abordaje del Neurodesarrollo Infantil en Heredia, Costa Rica. Especialistas en TDAH, TEA y condiciones del desarrollo infantil."
      },
      navigation: {
        label: "Navegación principal"
      }
    },
    footer: {
      description: "Centro integral de salud infantil en Heredia, Costa Rica. Ofrecemos neuropsicología, terapia de lenguaje, terapia ocupacional, psicología infantil y psicopedagogía para niños y adolescentes.",
      quickLinks: "Enlaces Rápidos",
      services: "Servicios",
      contact: "Información de Contacto",
      followUs: "Síguenos",
      rights: "Todos los derechos reservados.",
      socialMedia: {
        facebook: "Seguir en Facebook",
        instagram: "Seguir en Instagram",
        whatsapp: "Contactar por WhatsApp"
      }
    },
    homepage: {
      hero: {
        title: "Centro de Especialidades para el abordaje del Neurodesarrollo Infantil en Heredia",
        subtitle: "Una solución integral para población infanto-juvenil con alteraciones del desarrollo. Atendemos niños, niñas, y jóvenes desde el nacimiento hasta los 18 años con enfoques basados en evidencia científica y en equipo con la Familia, la Escuela y Profesionales.",
        imageAlt: "Niños felices en terapia",
        certifiedText: "Centro Certificado",
        specialistsText: "Especialistas en Neuropsicología"
      },
      stats: [
        {
          number: "+500",
          label: "Niños atendidos",
          description: "Familias que confían en nosotros"
        },
        {
          number: "12+",
          label: "Años de experiencia",
          description: "Especialistas certificados"
        },
        {
          number: "98%",
          label: "Índice de satisfacción",
          description: "Resultados comprobados"
        },
        {
          number: "8",
          label: "Especialistas",
          description: "Equipo multidisciplinario"
        }
      ],
      threePillarsModel: {
        title: "Nuestro Modelo Integral",
        subtitle: "En Neuro Peques trabajamos con un modelo que abarca los 3 pilares fundamentales del desarrollo infantil para garantizar resultados óptimos"
      },
      cta: {
        title: "¿Listo para dar el primer paso?",
        subtitle: "Contáctanos hoy mismo para agendar una evaluación inicial y descubrir cómo podemos ayudar a tu hijo/a a alcanzar su máximo potencial."
      }
    },
    ctaSection: {
      defaultTitle: "¿Listo para dar el primer paso?",
      defaultDescription: "Contáctanos hoy mismo para agendar una evaluación inicial y descubrir cómo podemos ayudar a tu hijo/a a alcanzar su máximo potencial.",
      defaultButtonText: "Agenda una Cita"
    },
    servicesPage: {
      seo: {
        title: "Servicios",
        description: "Servicios especializados para el desarrollo integral de población infanto-juvenil en Heredia, Costa Rica. Neuropsicología infantil, terapia del lenguaje, terapia ocupacional y más.",
        keywords: "servicios neurodesarrollo, neuropsicología infantil, terapia del lenguaje, terapia ocupacional, psicología infantil, psicopedagogía, psiquiatría, Costa Rica, Heredia"
      },
      pageHeader: {
        title: "Cómo Podemos Ayudarte",
        subtitle: "Servicios especializados para el desarrollo integral de niños y adolescentes"
      },
      introSection: {
        title: "Nuestros Servicios",
        description1: "En Neuro Peques ofrecemos atención integral especializada para niños y adolescentes. Como centro enfocado en salud infantil, brindamos servicios de neuropsicología (nuestra especialidad principal), terapia de lenguaje, terapia ocupacional, psicología infantil y psicopedagogía.",
        description2: "Nuestro enfoque terapéutico se basa en tratamientos respaldados por la evidencia científica y los avances en neurociencia, adaptando nuestros servicios a las necesidades específicas de cada niño/a y al contexto costarricense."
      },
      specializedServices: {
        title: "Servicios Especializados",
        subtitle: "Atención integral para el desarrollo y bienestar de niños y adolescentes",
        seeMoreDetails: "Ver más detalles →"
      },
      integralApproach: {
        title: "Enfoque Integral",
        description: "Trabajamos con un modelo multidisciplinario que abarca los 3 pilares fundamentales: Familia, Escuela y Profesionales, adaptando nuestros servicios a las necesidades específicas de cada niño/a.",
        personalizedCare: {
          title: "Atención Personalizada",
          description: "Cada plan se adapta a las necesidades específicas del niño/a"
        },
        evidenceBased: {
          title: "Basado en Evidencia",
          description: "Tratamientos respaldados por investigación científica"
        },
        continuousFollowUp: {
          title: "Seguimiento Continuo",
          description: "Monitoreo del progreso y ajustes regulares"
        }
      },
      finalCta: {
        title: "¿Necesitas más información sobre nuestros servicios?",
        description: "Contáctanos para agendar una consulta inicial y conocer cómo podemos ayudar a tu hijo/a.",
        buttonText: "Contáctanos Hoy"
      },
      services: {
        neuropsychology: {
          title: "Neuropsicología Infantil",
          description: "Nuestra especialidad principal. Evaluación neuropsicológica integral, diagnóstico y estimulación cognitiva para condiciones del neurodesarrollo."
        },
        speechTherapy: {
          title: "Terapia de Lenguaje",
          description: "Intervención especializada para trastornos de la comunicación, retrasos del lenguaje y problemas de articulación."
        },
        occupationalTherapy: {
          title: "Terapia Ocupacional",
          description: "Desarrollo de habilidades motoras, integración sensorial y destrezas para actividades de la vida diaria."
        },
        psychology: {
          title: "Psicología Infantil",
          description: "Atención psicológica especializada para retos emocionales, conductuales y sociales en niños y adolescentes."
        },
        psychopedagogy: {
          title: "Psicopedagogía",
          description: "Apoyo especializado para dificultades específicas de aprendizaje como dislexia, discalculia y disgrafía."
        },
        psychiatry: {
          title: "Psiquiatría",
          description: "Evaluación, diagnóstico y tratamiento especializado de condiciones psiquiátricas en población infanto-juvenil y adulta, incluyendo condiciones del neurodesarrollo, estado de ánimo y ansiedad."
        },
        // TEMPORALMENTE OCULTO - Medicina General Infantil
        /*
        generalMedicine: {
          title: "Medicina General Infantil",
          description: "Atención médica general para niños, control de crecimiento y desarrollo, coordinado con servicios especializados."
        }
        */
      }
    },
    specialists: {
      title: "Nuestros Especialistas",
      subtitle: "Conoce a los profesionales que conforman nuestro equipo multidisciplinario",
      multidisciplinaryApproach: {
        title: "Enfoque Multidisciplinario",
        description1: "En Neuro Peques, valoramos el trabajo en equipo como pilar fundamental para brindar una atención completa e integral. Nuestras especialistas trabajan de manera coordinada para evaluar y abordar cada caso desde diferentes perspectivas profesionales.",
        description2: "Todos nuestros profesionales cuentan con formación especializada en sus respectivas áreas y se mantienen en constante actualización para implementar las técnicas más avanzadas basadas en la evidencia científica.",
        highlight: "Nuestro equipo se caracteriza no solo por su excelencia técnica, sino también por su calidez y empatía, creando un ambiente acogedor donde los niños se sienten comprendidos y motivados durante su proceso terapéutico."
      },
      viewCompleteProfile: "Ver Perfil Completo",
      wantToMeetTeam: "¿Quieres conocer a nuestro equipo?",
      meetTeamDescription: "Agenda una cita inicial y conoce personalmente a nuestros especialistas. Te orientaremos sobre cuál es el profesional más adecuado según las necesidades específicas de tu hijo/a."
    },
    services: {
      title: "Nuestros Servicios",
      subtitle: "Ofrecemos una atención integral y especializada para el desarrollo infantil",
      neuropsychology: {
        title: "Neuropsicología Infantil",
        description: "Evaluación y tratamiento especializado para condiciones del neurodesarrollo"
      },
      psychology: {
        title: "Psicología Infantil",
        description: "Atención psicológica especializada para niños y adolescentes"
      },
      psychopedagogy: {
        title: "Psicopedagogía",
        description: "Apoyo especializado para dificultades de aprendizaje"
      },
      speechTherapy: {
        title: "Terapia de Lenguaje",
        description: "Intervención para trastornos de la comunicación y lenguaje"
      },
      occupationalTherapy: {
        title: "Terapia Ocupacional",
        description: "Desarrollo de habilidades motoras y autonomía funcional"
      },
      psychiatry: {
        title: "Psiquiatría",
        description: "Evaluación, diagnóstico y tratamiento de condiciones psiquiátricas en población infanto-juvenil y adulta"
      },
      // TEMPORALMENTE OCULTO - Medicina General Infantil
      /*
      generalMedicine: {
        title: "Medicina General Infantil",
        description: "Atención médica integral para niños y adolescentes"
      }
      */
    },
    aboutUs: {
      title: "Quiénes Somos",
      subtitle: "Conoce más sobre Neuro Peques y nuestro compromiso con el desarrollo infantil",
      description: "Centro de Especialidades para el abordaje del Neurodesarrollo Infantil privado que brinda atención integral a niños, niñas, y jóvenes desde el nacimiento hasta los 18 años en Heredia, Costa Rica.",
      pageHeader: {
        title: "Conoce a Neuro Peques",
        subtitle: "Un equipo comprometido con el desarrollo y bienestar de los niños y sus familias"
      },
      seo: {
        title: "Quienes Somos",
        description: "Conoce a Neuro Peques, centro de especialidades para el abordaje del neurodesarrollo infantil en Heredia, Costa Rica. Equipo multidisciplinario especializado en TDAH, TEA y condiciones del desarrollo.",
        keywords: "Neuro Peques, centro neurodesarrollo, especialidades infantiles, TDAH, TEA, condiciones desarrollo, altas capacidades, Costa Rica, Heredia, equipo multidisciplinario, Mónica Vargas"
      },
      missionVision: {
        title: "Nuestra Misión y Visión",
        mission: {
          title: "Misión",
          description: "En Neuro Peques, somos un Centro de Especialidades para el abordaje del Neurodesarrollo Infantil privado que brinda atención a niños, niñas, y jóvenes desde el nacimiento hasta los 18 años en Heredia, Costa Rica. Nuestro enfoque terapéutico se basa en enfoques basados en evidencia científica y en equipo con la Familia, la Escuela y Profesionales. Implementamos tratamientos innovadores respaldados por la Neurorehabilitación, la medicina basada en la evidencia y los avances en neurociencia y neuroplasticidad."
        },
        vision: {
          title: "Visión y Filosofía",
          description1: "Nuestra meta principal es conseguir que cada niño/a alcance su máximo nivel de autonomía, mejorando así su calidad de vida y participación social. Creemos firmemente que cada niño/a merece ser comprendido en su individualidad, por lo que nuestro compromiso es ofrecer un apoyo continuo no solo a nuestros pacientes, sino también a sus familias y entornos educativos.",
          description2: "Trabajamos con programas de intervención personalizados que establecen objetivos cuantificables a corto plazo y una visión clara a largo plazo. Nuestro equipo multidisciplinario está altamente capacitado y actualizado en las últimas técnicas y avances científicos, siempre adaptando nuestras intervenciones al contexto costarricense."
        }
      },
      team: {
        title: "Nuestro Equipo",
        subtitle: "En Neuro Peques valoramos el trabajo multidisciplinario como pilar fundamental para brindar una atención completa e integral. Nuestro equipo de especialistas trabaja de manera coordinada para evaluar y abordar cada caso desde diferentes perspectivas profesionales, garantizando un enfoque integral del desarrollo infantil.",
        viewCompleteProfile: "Ver perfil completo"
      },
      facilities: {
        title: "Nuestras Instalaciones",
        subtitle: "Contamos con un espacio especialmente diseñado para crear un ambiente acogedor y seguro donde los niños se sientan cómodos y motivados durante sus terapias. Nuestras instalaciones combinan funcionalidad terapéutica con un ambiente cálido que favorece el trabajo y el bienestar de nuestros pacientes.",
        features: [
          "Consultorios privados adaptados para diferentes edades",
          "Espacios para terapia y evaluación neuropsicológica",
          "Área de juegos terapéuticos y estimulación sensorial",
          "Sala de espera confortable para familias"
        ],
        reception: {
          title: "Recepción",
          description: "Área de bienvenida con diseño colorido y acogedor"
        },
        therapyRoom: {
          title: "Sala de Terapia",
          description: "Con materiales de estimulación y juegos didácticos"
        },
        sensoryArea: {
          title: "Área Sensorial",
          description: "Juegos terapéuticos y estimulación sensorial"
        },
        designedForChildren: {
          title: "Un Espacio Diseñado para los Niños",
          description: "Nuestras instalaciones cuentan con:"
        }
      },
      finalCta: {
        title: "¿Quieres conocer nuestras instalaciones?",
        description: "Te invitamos a agendar una visita para conocer nuestro espacio y conversar sobre cómo podemos ayudar a tu hijo/a.",
        buttonText: "Agenda una Visita"
      }
    },
    contact: {
      title: "Contacto",
      subtitle: "Contáctanos para agendar una cita o resolver tus dudas",
      schedule: "Horario de Atención",
      address: "Dirección",
      phone: "Teléfono",
      email: "Correo Electrónico",
      pageHeader: {
        title: "Contáctanos",
        subtitle: "Estamos aquí para ayudarte. Contáctanos para agendar una cita o resolver cualquier duda sobre nuestros servicios."
      },
      seo: {
        title: "Contacto",
        description: "Contacta con Neuro Peques en Heredia, Costa Rica. Agenda tu cita para evaluación neuropsicológica, terapia del lenguaje, terapia ocupacional y más servicios especializados.",
        keywords: "contacto Neuro Peques, agendar cita, evaluación neuropsicológica, terapia infantil, Costa Rica, Heredia, teléfono, email"
      },
      contactInfo: {
        title: "Información de Contacto",
        address: {
          title: "Dirección",
          mall: "Mall Paseo de las Flores",
          floor: "5to piso de la Torre de Negocios",
          city: "Heredia, Costa Rica"
        },
        phone: {
          title: "Teléfono",
          number: "+506 8583-8056"
        },
        email: {
          title: "Email",
          address: "info@neuropequescr.com"
        },
        schedule: {
          title: "Horario de Atención",
          monday: "Lunes: 1:00 pm - 6:00 pm",
          tuesdayFriday: "Martes a Viernes: 9:00 am - 6:00 pm",
          saturday: "Sábados: 8:00 am - 1:00 pm"
        }
      },
      location: {
        title: "Ubicación del Centro",
        mapTitle: "Ubicación en el Mapa",
        markerInfo: "Neuro Peques - Centro de Especialidades para el abordaje del Neurodesarrollo Infantil",
        address: "Mall Paseo de las Flores, 5to piso Torre de Negocios, Heredia",
        openFullMap: "Abrir Mapa Completo",
        openFullMapTitle: "Abrir mapa en pantalla completa",
        googleMaps: "Google Maps",
        waze: "Waze",
        locationInfo: {
          title: "Información de Ubicación",
          items: [
            "Fácil acceso desde San José y otras ciudades del Valle Central",
            "Estacionamiento gratuito y de pago disponible",
            "Parada de autobús a 100 metros del centro comercial"
          ]
        }
      },
      whatsapp: {
        title: "¡Escríbenos por WhatsApp!",
        description: "Para consultas rápidas o agendar citas, contáctanos directamente por WhatsApp",
        buttonText: "Contactar por WhatsApp",
        message: "Hola, me interesa obtener más información sobre los servicios de Neuro Peques. ¿Podrían brindarme información sobre disponibilidad y el proceso de evaluación inicial?"
      }
    },
    testimonials: {
      title: "Testimonios",
      subtitle: "Experiencias de familias que han confiado en nosotros",
      pageHeader: {
        title: "Testimonios",
        subtitle: "Experiencias de familias que han confiado en Neuro Peques para el desarrollo y bienestar de sus hijos"
      },
      seo: {
        title: "Testimonios",
        description: "Experiencias reales de familias que han confiado en Neuro Peques para el desarrollo y bienestar de sus hijos. Testimonios de éxito en TDAH, TEA y condiciones del desarrollo en Heredia, Costa Rica.",
        keywords: "testimonios Neuro Peques, experiencias familias, TDAH, TEA, condiciones desarrollo, altas capacidades, terapia infantil, Costa Rica, Heredia, éxito terapéutico"
      },
      heroQuote: "Cada niño/a nos enseña algo nuevo y cada familia nos inspira a seguir mejorando",
      heroImageAlt: "Familia feliz después de una sesión en Neuro Peques",
      testimonialsSection: {
        title: "Lo que dicen nuestras familias",
        subtitle: "Estas son algunas experiencias compartidas por padres y madres que han confiado en Neuro Peques para el diagnóstico y tratamiento de sus hijos."
      },
      shareExperience: {
        title: "¿Quieres compartir tu experiencia?",
        description: "Tu historia puede ser de gran ayuda para otras familias que están buscando apoyo para sus hijos. Nos encantaría conocer cómo ha sido tu experiencia en Neuro Peques.",
        buttonText: "Compartir mi Testimonio",
        note: "¡Tu opinión es muy valiosa para nosotros y para otras familias!"
      },
      finalCta: {
        title: "¿Necesitas ayuda con el desarrollo de tu hijo/a?",
        description: "En Neuro Peques estamos listos para ayudarte. Contáctanos para agendar una evaluación inicial.",
        buttonText: "Agenda una Consulta"
      }
    },
    disorders: {
      title: "Trastornos del Desarrollo",
      subtitle: "Información para padres sobre condiciones del neurodesarrollo infantil",
      description: "Información para padres sobre condiciones del neurodesarrollo infantil y cómo podemos ayudar en Heredia, Costa Rica.",
      pageHeader: {
        title: "Condiciones del Desarrollo Infantil",
        subtitle: "Información para padres sobre condiciones del neurodesarrollo y cómo podemos ayudar"
      },
      seo: {
        title: "Condiciones del Desarrollo Infantil",
        description: "Información para padres sobre condiciones del neurodesarrollo infantil en Heredia, Costa Rica. TDAH, TEA, altas capacidades, dislexia, discalculia, trastorno aprendizaje no verbal y más. Expertos en diagnóstico e intervención temprana.",
        keywords: "condiciones desarrollo infantil, condiciones neurodesarrollo, TDAH, TEA, altas capacidades intelectuales, dislexia, discalculia, trastorno aprendizaje no verbal, enfermedades raras, Costa Rica, Heredia, diagnóstico infantil, intervención temprana"
      },
      introSection: {
        title: "Sobre las Condiciones del Desarrollo",
        description1: "En esta sección encontrará información sobre las diferentes condiciones del neurodesarrollo infantil que abordamos en Neuro Peques. Nuestro objetivo es orientar a padres y cuidadores sobre las principales características de estas condiciones, signos de alerta y posibles abordajes terapéuticos.",
        description2: "Es importante entender que cada niño es único, independientemente de su diagnóstico. Las manifestaciones de estas condiciones varían enormemente de un niño a otro, y nuestro enfoque siempre se adapta a las necesidades individuales y fortalezas específicas de cada niño.",
        teamInfo: "En Neuro Peques contamos con un equipo multidisciplinario especializado que trabaja en conjunto para ofrecer una evaluación integral y un abordaje personalizado para cada niño y su familia."
      },
      conditionsSection: {
        title: "Condiciones que Atendemos",
        subtitle: "Conoce más sobre las diferentes condiciones del neurodesarrollo que evaluamos y abordamos en nuestra clínica"
      },
      commonSigns: "Señales comunes a observar:",
      howWeHelp: "¿Cómo puede ayudar Neuro Peques?",
      viewRelatedServices: "Ver servicios relacionados",
      finalCta: {
        title: "¿Sospechas que tu hijo/a podría tener alguna de estas condiciones?",
        description: "Una evaluación temprana y un diagnóstico adecuado son fundamentales para comenzar la intervención. Contáctanos para agendar una consulta inicial.",
        buttonText: "Solicitar Evaluación"
      },
      conditions: {
        autism: {
          title: "Trastorno del Espectro Autista (TEA)",
          description: "El Trastorno del Espectro Autista (TEA) es una condición neurológica compleja que afecta la comunicación, la interacción social y puede incluir patrones de comportamiento e intereses restrictivos o repetitivos. El término 'espectro' refleja la amplia variedad de fortalezas y desafíos que pueden experimentar las personas con TEA, desde habilidades excepcionales en áreas específicas hasta dificultades significativas en la vida cotidiana.",
          signs: [
            "Dificultades en la comunicación verbal y no verbal (desde ausencia de habla hasta sutilezas en la comprensión del lenguaje)",
            "Retos en la interacción social y para establecer o mantener relaciones con otros niños",
            "Intereses restringidos o comportamientos repetitivos que pueden ser inusuales en intensidad o enfoque",
            "Reacciones inusuales a estímulos sensoriales (hipersensibilidad o hiposensibilidad a sonidos, luces, texturas)",
            "Preferencia por rutinas establecidas y posible resistencia a cambios",
            "Posible presencia de habilidades excepcionales en áreas específicas (memoria, música, matemáticas, etc.)"
          ],
          help: "Nuestro equipo especializado en TEA ofrece evaluaciones detalladas para el diagnóstico temprano del autismo en niños desde los 18 meses. Desarrollamos planes de intervención personalizados basados en evidencia científica que incluyen terapias para mejorar habilidades sociales, comunicativas y de autorregulación. Trabajamos con un enfoque centrado en las fortalezas del niño, involucrando activamente a la familia y proporcionando estrategias prácticas para implementar en todos los entornos del niño.",
          imageAlt: "Niño con autismo en sesión terapéutica"
        },
        adhd: {
          title: "Trastorno por Déficit de Atención e Hiperactividad (TDAH)",
          description: "El TDAH es una condición neurobiológica que afecta la capacidad de regulación atencional, el control de impulsos y el nivel de actividad. Se considera una de las condiciones neuroconductuales más comunes en la infancia, afectando aproximadamente al 5-7% de los niños en edad escolar. El TDAH tiene una base genética importante y afecta el funcionamiento de ciertas áreas cerebrales y neurotransmisores relacionados con la atención y el autocontrol.",
          signs: [
            "Dificultad persistente para mantener la atención en tareas escolares, conversaciones o actividades lúdicas",
            "Parece no escuchar cuando se le habla directamente, incluso en ausencia de distracciones obvias",
            "Se distrae fácilmente por estímulos externos o pensamientos no relacionados",
            "Dificultad para organizar tareas y actividades, y frecuente pérdida de objetos necesarios",
            "En algunos casos, inquietud motora excesiva, dificultad para permanecer sentado o esperar su turno",
            "Posible impulsividad que se manifiesta en interrupciones o decisiones precipitadas"
          ],
          help: "En Neuro Peques ofrecemos una evaluación comprehensiva del TDAH que abarca múltiples contextos (hogar, escuela) e incluye pruebas neuropsicológicas específicas. Nuestro abordaje multimodal combina intervenciones conductuales, entrenamiento en funciones ejecutivas (organización, planificación, autorregulación), apoyo académico personalizado y orientación familiar. Proporcionamos estrategias concretas para mejorar el desempeño escolar, las habilidades sociales y la autoestima, trabajando en coordinación con la escuela.",
          imageAlt: "Niño con TDAH en sesión de terapia de atención"
        },
        dyslexia: {
          title: "Dislexia y Trastornos Específicos del Aprendizaje",
          description: "La dislexia es un trastorno específico del aprendizaje de origen neurobiológico que afecta principalmente el procesamiento fonológico y la adquisición de la lectoescritura. Se caracteriza por dificultades en el reconocimiento preciso y fluido de palabras, problemas de decodificación y ortografía, a pesar de una inteligencia normal y oportunidades educativas adecuadas. Otros trastornos específicos del aprendizaje incluyen la disgrafía (dificultades en la expresión escrita) y la discalculia (dificultades con los conceptos y procedimientos matemáticos).",
          signs: [
            "Dificultad para aprender la relación entre letras y sonidos (conciencia fonológica)",
            "Lectura lenta, con esfuerzo y baja fluidez, con frecuentes errores de precisión",
            "Dificultades persistentes en ortografía y expresión escrita",
            "Posibles problemas en matemáticas, especialmente en la memorización de operaciones básicas",
            "Evitación de actividades relacionadas con la lectura o la escritura",
            "Con frecuencia, buenas habilidades de razonamiento verbal y comprensión oral"
          ],
          help: "Realizamos evaluaciones especializadas en trastornos del aprendizaje para identificar el perfil único de fortalezas y debilidades de cada niño. Nuestro enfoque terapéutico incluye programas estructurados y sistemáticos basados en metodologías con evidencia científica, como estrategias multisensoriales y entrenamiento en conciencia fonológica. Proporcionamos recomendaciones detalladas y específicas para adaptaciones en el entorno escolar y apoyo en el hogar, enfocándonos en desarrollar estrategias compensatorias y potenciar las áreas de fortaleza del niño.",
          imageAlt: "Niña con dislexia recibiendo apoyo en la lectura"
        },
        intellectualDisability: {
          title: "Discapacidad Intelectual",
          description: "La discapacidad intelectual es una condición caracterizada por limitaciones significativas tanto en el funcionamiento intelectual (razonamiento, aprendizaje, resolución de problemas) como en la conducta adaptativa, que abarca habilidades sociales y prácticas cotidianas. Esta condición se origina antes de los 18 años y puede variar en su severidad desde leve hasta profunda. Es importante destacar que, con los apoyos adecuados, las personas con discapacidad intelectual pueden desarrollar numerosas habilidades y disfrutar de una vida plena.",
          signs: [
            "Retraso en los hitos del desarrollo (sentarse, caminar, hablar)",
            "Dificultades de aprendizaje más significativas que lo esperado para la edad",
            "Limitaciones en habilidades conceptuales como lectura, escritura, matemáticas, tiempo, dinero",
            "Retos en habilidades sociales como la comprensión de reglas sociales, interacción con pares y comunicación",
            "Dificultades en actividades de la vida diaria y autonomía personal",
            "Necesidad de más tiempo y repetición para aprender nuevas habilidades"
          ],
          help: "Ofrecemos una evaluación comprehensiva del funcionamiento cognitivo, adaptativo y del desarrollo que permite determinar la presencia de discapacidad intelectual y su nivel de severidad. Nuestro enfoque de intervención se centra en desarrollar el máximo potencial de cada niño, estableciendo metas realistas pero ambiciosas. Trabajamos en el desarrollo de habilidades funcionales para la vida diaria, comunicación efectiva, integración social y habilidades prelaborales según la edad. Proporcionamos orientación detallada a familias y escuelas sobre adaptaciones, apoyos y recursos comunitarios disponibles.",
          imageAlt: "Niño con discapacidad intelectual en sesión de terapia"
        },
        prematurity: {
          title: "Prematuridad y Desarrollo",
          description: "La prematuridad (nacimiento antes de las 37 semanas de gestación) puede afectar diversos aspectos del desarrollo infantil debido a la inmadurez de órganos y sistemas, particularmente el sistema nervioso central. Los bebés prematuros, especialmente aquellos con muy bajo peso al nacer o nacidos antes de las 32 semanas, pueden presentar un mayor riesgo de complicaciones o retrasos en su desarrollo neurológico, sensorial, motor, cognitivo, del lenguaje y socioemocional.",
          signs: [
            "Posibles retrasos en la adquisición de hitos motores (sostener la cabeza, sentarse, gatear, caminar)",
            "Desarrollo más lento del lenguaje expresivo y receptivo",
            "Mayor sensibilidad a estímulos sensoriales (ruidos, luces, texturas)",
            "Posibles dificultades en la regulación (alimentación, sueño, llanto, consolabilidad)",
            "Mayor riesgo de problemas de atención, aprendizaje o comportamiento en edad escolar",
            "En algunos casos, particularmente en la prematuridad extrema, mayor incidencia de condiciones como parálisis cerebral, trastornos visuales o auditivos"
          ],
          help: "Nuestro equipo ofrece programas de seguimiento del neurodesarrollo específicamente diseñados para bebés y niños nacidos prematuramente. Realizamos evaluaciones tempranas y periódicas para identificar cualquier señal de alerta o retraso en el desarrollo. Ofrecemos intervención temprana para potenciar el desarrollo motor, cognitivo, del lenguaje y socioemocional, adaptando las terapias a la edad corregida del niño. Proporcionamos orientación específica a los padres sobre cómo estimular adecuadamente a su hijo prematuro, respetando sus ritmos y necesidades particulares.",
          imageAlt: "Bebé prematuro recibiendo terapia de estimulación temprana"
        },
        rareDiseases: {
          title: "Enfermedades Raras con Afectación del Neurodesarrollo",
          description: "Las enfermedades raras son condiciones que afectan a una pequeña proporción de la población (menos de 5 por cada 10,000 personas). Muchas enfermedades raras son de origen genético y pueden afectar el desarrollo neurológico infantil. Estas condiciones pueden presentar síntomas neurológicos, cognitivos, conductuales o físicos diversos, y frecuentemente requieren un abordaje multidisciplinario especializado para su manejo.",
          signs: [
            "Combinación inusual de síntomas o características que no corresponden a condiciones comunes",
            "Retrasos significativos o patrones atípicos en el desarrollo motor, del lenguaje, cognitivo o social",
            "Regresión o pérdida de habilidades previamente adquiridas",
            "Características físicas distintivas o alteraciones visibles en la estructura corporal",
            "Historia familiar de condiciones genéticas o trastornos similares",
            "Hospitalizaciones frecuentes o complicaciones médicas recurrentes"
          ],
          help: "Nuestro equipo colabora estrechamente con especialistas médicos en el abordaje de enfermedades raras que afectan el neurodesarrollo. Ofrecemos evaluaciones neuropsicológicas especializadas para determinar fortalezas y necesidades específicas, incluso en perfiles clínicos complejos. Desarrollamos programas de intervención personalizados centrados en maximizar el potencial de cada niño y mejorar su calidad de vida. Proporcionamos orientación detallada a familias sobre recursos, ayudas técnicas, y estrategias de manejo, y facilitamos la conexión con asociaciones de pacientes y recursos comunitarios específicos para enfermedades raras.",
          imageAlt: "Niño con enfermedad rara en sesión terapéutica"
        }
      }
    },
    errorPages: {
      notFound: {
        title: "Página no encontrada",
        message: "Lo sentimos, la página que buscas no existe o ha sido movida.",
        suggestions: {
          services: {
            title: "¿Buscabas nuestros servicios?",
            items: [
              "Neuropsicología Infantil",
              "Psicología Infantil",
              "Psicopedagogía",
              "Terapia de Lenguaje",
              "Terapia Ocupacional",
              // "Medicina General Infantil" // TEMPORALMENTE OCULTO
            ]
          }
        }
      },
      generic: {
        title: "Error inesperado",
        message: "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo."
      }
    }
  },
  en: {
    navigation: {
      home: "Home",
      aboutUs: "About Us",
      services: "Services",
      developmentalConditions: "Developmental Conditions",
      ourTests: "Our Tests",
      testimonials: "Testimonials",
      resources: "Resources",
      contact: "Contact"
    },
    common: {
      scheduleAppointment: "Schedule Appointment",
      loading: "Loading…",
      back: "Back",
      home: "Home",
      seeMore: "See more",
      readMore: "Read more",
      contactUs: "Contact Us",
      learnMore: "Learn More",
      viewProfile: "View Profile",
      scheduleConsultation: "Schedule Consultation",
      scheduleEvaluation: "Schedule Evaluation",
      viewAllServices: "View All Services",
      viewAllSpecialists: "View All Specialists",
      viewRelatedServices: "View related services"
    },
    header: {
      scheduleAppointment: "Schedule Appointment",
      contactInfo: {
        schedule: "Mon 1-6pm, Tue-Fri 9am-6pm, Sat 8am-1pm",
        phone: "+506 8583-8056",
        phoneLabel: "Call main phone number",
        email: "info@neuropequescr.com",
        emailLabel: "Send email",
        contactPageLabel: "Go to contact page to schedule an appointment"
      },
      logo: {
        label: "Go to Neuro Peques main page - Specialty Center for Child Neurodevelopment Approach",
        alt: "Neuro Peques - Logo of the Specialty Center for Child Neurodevelopment Approach in Heredia, Costa Rica. Specialists in ADHD, ASD and child development disorders."
      },
      navigation: {
        label: "Main navigation"
      }
    },
    footer: {
      description: "Comprehensive child health center in Heredia, Costa Rica. We offer neuropsychology, speech therapy, occupational therapy, child psychology and psychopedagogy for children and adolescents.",
      quickLinks: "Quick Links",
      services: "Services",
      contact: "Contact Information",
      followUs: "Follow Us",
      rights: "All rights reserved.",
      socialMedia: {
        facebook: "Follow on Facebook",
        instagram: "Follow on Instagram",
        whatsapp: "Contact via WhatsApp"
      }
    },
    homepage: {
      hero: {
        title: "Specialty Center for Child Neurodevelopment Approach in Heredia",
        subtitle: "A comprehensive solution for children and youth population with developmental disorders. We serve children, girls, and youth from birth to 18 years with evidence-based approaches and as a team with the Family, School and Professionals.",
        imageAlt: "Happy children in therapy",
        certifiedText: "Certified Center",
        specialistsText: "Neuropsychology Specialists"
      },
      stats: [
        {
          number: "+500",
          label: "Children served",
          description: "Families who trust us"
        },
        {
          number: "12+",
          label: "Years of experience",
          description: "Certified specialists"
        },
        {
          number: "98%",
          label: "Satisfaction rate",
          description: "Proven results"
        },
        {
          number: "8",
          label: "Specialists",
          description: "Multidisciplinary team"
        }
      ],
      threePillarsModel: {
        title: "Our Integral Model",
        subtitle: "At Neuro Peques we work with a model that covers the 3 fundamental pillars of child development to ensure optimal results"
      },
      cta: {
        title: "Ready to take the first step?",
        subtitle: "Contact us today to schedule an initial evaluation and discover how we can help your child reach their full potential."
      }
    },
    ctaSection: {
      defaultTitle: "Ready to take the first step?",
      defaultDescription: "Contact us today to schedule an initial evaluation and discover how we can help your child reach their full potential.",
      defaultButtonText: "Schedule Appointment"
    },
    servicesPage: {
      seo: {
        title: "Services",
        description: "Specialized services for the comprehensive development of children and adolescents in Heredia, Costa Rica. Child neuropsychology, speech therapy, occupational therapy, psychiatry and more.",
        keywords: "neurodevelopment services, child neuropsychology, speech therapy, occupational therapy, child psychology, psychopedagogy, psychiatry, Costa Rica, Heredia"
      },
      pageHeader: {
        title: "How We Can Help You",
        subtitle: "Specialized services for the comprehensive development of children and adolescents"
      },
      introSection: {
        title: "Our Services",
        description1: "At Neuro Peques we offer comprehensive specialized care for children and adolescents. As a center focused on child health, we provide neuropsychology services (our main specialty), speech therapy, occupational therapy, child psychology and psychopedagogy.",
        description2: "Our therapeutic approach is based on treatments supported by scientific evidence and advances in neuroscience, adapting our services to the specific needs of each child and the Costa Rican context."
      },
      specializedServices: {
        title: "Specialized Services",
        subtitle: "Comprehensive care for the development and well-being of children and adolescents",
        seeMoreDetails: "See more details →"
      },
      integralApproach: {
        title: "Integral Approach",
        description: "We work with a multidisciplinary model that covers the 3 fundamental pillars: Family, School and Professionals, adapting our services to the specific needs of each child.",
        personalizedCare: {
          title: "Personalized Care",
          description: "Each plan is adapted to the child's specific needs"
        },
        evidenceBased: {
          title: "Evidence-Based",
          description: "Treatments supported by scientific research"
        },
        continuousFollowUp: {
          title: "Continuous Follow-up",
          description: "Progress monitoring and regular adjustments"
        }
      },
      finalCta: {
        title: "Need more information about our services?",
        description: "Contact us to schedule an initial consultation and learn how we can help your child.",
        buttonText: "Contact Us Today"
      },
      services: {
        neuropsychology: {
          title: "Child Neuropsychology",
          description: "Our main specialty. Comprehensive neuropsychological evaluation, diagnosis and cognitive stimulation for neurodevelopmental disorders."
        },
        speechTherapy: {
          title: "Speech Therapy",
          description: "Specialized intervention for communication disorders, language delays and articulation problems."
        },
        occupationalTherapy: {
          title: "Occupational Therapy",
          description: "Development of motor skills, sensory integration and skills for activities of daily living."
        },
        psychology: {
          title: "Child Psychology",
          description: "Specialized psychological care for emotional, behavioral and social challenges in children and adolescents."
        },
        psychopedagogy: {
          title: "Psychopedagogy",
          description: "Specialized support for specific learning difficulties such as dyslexia, dyscalculia and dysgraphia."
        },
        psychiatry: {
          title: "Child and Adolescent Psychiatry",
          description: "Specialized evaluation, diagnosis and treatment of psychiatric conditions in children and adolescents, including neurodevelopmental disorders, mood and anxiety disorders."
        },
        generalMedicine: {
          title: "General Child Medicine",
          description: "General medical care for children, growth and development monitoring, coordinated with specialized services."
        }
      }
    },
    specialists: {
      title: "Our Specialists",
      subtitle: "Meet the professionals who make up our multidisciplinary team",
      multidisciplinaryApproach: {
        title: "Multidisciplinary Approach",
        description1: "At Neuro Peques, we value teamwork as a fundamental pillar to provide complete and comprehensive care. Our specialists work in a coordinated manner to evaluate and address each case from different professional perspectives.",
        description2: "All our professionals have specialized training in their respective areas and maintain constant updating to implement the most advanced techniques based on scientific evidence.",
        highlight: "Our team is characterized not only by their technical excellence, but also by their warmth and empathy, creating a welcoming environment where children feel understood and motivated during their therapeutic process."
      },
      viewCompleteProfile: "View Complete Profile",
      wantToMeetTeam: "Want to meet our team?",
      meetTeamDescription: "Schedule an initial appointment and meet our specialists in person. We will guide you on which professional is most suitable according to your child's specific needs."
    },
    services: {
      title: "Our Services",
      subtitle: "We offer comprehensive and specialized care for child development",
      neuropsychology: {
        title: "Child Neuropsychology",
        description: "Specialized evaluation and treatment for neurodevelopmental disorders"
      },
      psychology: {
        title: "Child Psychology",
        description: "Specialized psychological care for children and adolescents"
      },
      psychopedagogy: {
        title: "Psychopedagogy",
        description: "Specialized support for learning difficulties"
      },
      speechTherapy: {
        title: "Speech Therapy",
        description: "Intervention for communication and language disorders"
      },
      occupationalTherapy: {
        title: "Occupational Therapy",
        description: "Development of motor skills and functional autonomy"
      },
      psychiatry: {
        title: "Child and Adolescent Psychiatry",
        description: "Specialized evaluation, diagnosis and treatment of psychiatric conditions in children and adolescents"
      },
      generalMedicine: {
        title: "General Child Medicine",
        description: "Comprehensive medical care for children and adolescents"
      }
    },
    aboutUs: {
      title: "About Us",
      subtitle: "Learn more about Neuro Peques and our commitment to child development",
      description: "Private Specialty Center for Child Neurodevelopment Approach that provides comprehensive care to children, girls, and youth from birth to 18 years in Heredia, Costa Rica.",
      pageHeader: {
        title: "Meet Neuro Peques",
        subtitle: "A team committed to the development and well-being of children and their families"
      },
      seo: {
        title: "About Us",
        description: "Meet Neuro Peques, a specialized center for child neurodevelopment approach in Heredia, Costa Rica. Multidisciplinary team specialized in ADHD, ASD and development conditions.",
        keywords: "Neuro Peques, neurodevelopment center, child specialties, ADHD, ASD, development conditions, high intellectual abilities, Costa Rica, Heredia, multidisciplinary team, Mónica Vargas"
      },
      missionVision: {
        title: "Our Mission and Vision",
        mission: {
          title: "Mission",
          description: "At Neuro Peques, we are a private Specialty Center for Child Neurodevelopment Approach that provides care to children, girls, and youth from birth to 18 years in Heredia, Costa Rica. Our therapeutic approach is based on evidence-based approaches and as a team with the Family, School and Professionals. We implement innovative treatments supported by Neurorehabilitation, evidence-based medicine and advances in neuroscience and neuroplasticity."
        },
        vision: {
          title: "Vision and Philosophy",
          description1: "Our main goal is to ensure that each child reaches their maximum level of autonomy, thus improving their quality of life and social participation. We firmly believe that each child deserves to be understood in their individuality, which is why our commitment is to provide continuous support not only to our patients, but also to their families and educational environments.",
          description2: "We work with personalized intervention programs that establish quantifiable short-term objectives and a clear long-term vision. Our multidisciplinary team is highly trained and updated in the latest techniques and scientific advances, always adapting our interventions to the Costa Rican context."
        }
      },
      team: {
        title: "Our Team",
        subtitle: "At Neuro Peques we value multidisciplinary work as a fundamental pillar to provide complete and comprehensive care. Our team of specialists works in a coordinated manner to evaluate and address each case from different professional perspectives, guaranteeing a holistic approach to child development.",
        viewCompleteProfile: "View complete profile"
      },
      facilities: {
        title: "Our Facilities",
        subtitle: "We have a space specially designed to create a welcoming and safe environment where children feel comfortable and motivated during their therapies. Our facilities combine therapeutic functionality with a warm atmosphere that favors the work and well-being of our patients.",
        features: [
          "Private offices adapted for different ages",
          "Spaces for therapy and neuropsychological evaluation",
          "Therapeutic play area and sensory stimulation",
          "Comfortable waiting room for families"
        ],
        reception: {
          title: "Reception",
          description: "Welcome area with colorful and welcoming design"
        },
        therapyRoom: {
          title: "Therapy Room",
          description: "With stimulation materials and educational games"
        },
        sensoryArea: {
          title: "Sensory Area",
          description: "Therapeutic games and sensory stimulation"
        },
        designedForChildren: {
          title: "A Space Designed for Children",
          description: "Our facilities include:"
        }
      },
      finalCta: {
        title: "Want to see our facilities?",
        description: "We invite you to schedule a visit to see our space and talk about how we can help your child.",
        buttonText: "Schedule a Visit"
      }
    },
    contact: {
      title: "Contact",
      subtitle: "Contact us to schedule an appointment or resolve your questions",
      schedule: "Hours of Operation",
      address: "Address",
      phone: "Phone",
      email: "Email",
      pageHeader: {
        title: "Contact Us",
        subtitle: "We are here to help you. Contact us to schedule an appointment or resolve any questions about our services."
      },
      seo: {
        title: "Contact",
        description: "Contact Neuro Peques in Heredia, Costa Rica. Schedule your appointment for neuropsychological evaluation, speech therapy, occupational therapy and more specialized services.",
        keywords: "Neuro Peques contact, schedule appointment, neuropsychological evaluation, child therapy, Costa Rica, Heredia, phone, email"
      },
      contactInfo: {
        title: "Contact Information",
        address: {
          title: "Address",
          mall: "Mall Paseo de las Flores",
          floor: "5th floor of the Business Tower",
          city: "Heredia, Costa Rica"
        },
        phone: {
          title: "Phone",
          number: "+506 8583-8056"
        },
        email: {
          title: "Email",
          address: "info@neuropequescr.com"
        },
        schedule: {
          title: "Hours of Operation",
          monday: "Monday: 1:00 pm - 6:00 pm",
          tuesdayFriday: "Tuesday to Friday: 9:00 am - 6:00 pm",
          saturday: "Saturday: 8:00 am - 1:00 pm"
        }
      },
      location: {
        title: "Center Location",
        mapTitle: "Location on Map",
        markerInfo: "Neuro Peques - Specialty Center for Child Neurodevelopment Approach",
        address: "Mall Paseo de las Flores, 5th floor Business Tower, Heredia",
        openFullMap: "Open Full Map",
        openFullMapTitle: "Open map in full screen",
        googleMaps: "Google Maps",
        waze: "Waze",
        locationInfo: {
          title: "Location Information",
          items: [
            "Easy access from San José and other cities in the Central Valley",
            "Free and paid parking available",
            "Bus stop 100 meters from the shopping center"
          ]
        }
      },
      whatsapp: {
        title: "Write to us on WhatsApp!",
        description: "For quick queries or to schedule appointments, contact us directly via WhatsApp",
        buttonText: "Contact via WhatsApp",
        message: "Hello, I'm interested in getting more information about Neuro Peques services. Could you provide me with information about availability and the initial evaluation process?"
      },
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        message: "Message",
        send: "Send message",
        required: "Required field"
      }
    },
    testimonials: {
      title: "Testimonials",
      subtitle: "Experiences of families who have trusted us",
      pageHeader: {
        title: "Testimonials",
        subtitle: "Experiences of families who have trusted Neuro Peques for the development and well-being of their children"
      },
      seo: {
        title: "Testimonials",
        description: "Real experiences of families who have trusted Neuro Peques for the development and well-being of their children. Success testimonials in ADHD, ASD and development conditions in Heredia, Costa Rica.",
        keywords: "Neuro Peques testimonials, family experiences, ADHD, ASD, development conditions, high intellectual abilities, child therapy, Costa Rica, Heredia, therapeutic success"
      },
      heroQuote: "Every child teaches us something new and every family inspires us to keep improving",
      heroImageAlt: "Happy family after a session at Neuro Peques",
      testimonialsSection: {
        title: "What our families say",
        subtitle: "These are some experiences shared by parents who have trusted Neuro Peques for the diagnosis and treatment of their children."
      },
      shareExperience: {
        title: "Want to share your experience?",
        description: "Your story can be of great help to other families who are looking for support for their children. We would love to know how your experience at Neuro Peques has been.",
        buttonText: "Share my Testimonial",
        note: "Your opinion is very valuable to us and to other families!"
      },
      finalCta: {
        title: "Need help with your child's development?",
        description: "At Neuro Peques we are ready to help you. Contact us to schedule an initial evaluation.",
        buttonText: "Schedule a Consultation"
      }
    },
    disorders: {
      title: "Developmental Disorders",
      subtitle: "Information for parents about child neurodevelopment conditions",
      description: "Information for parents about child neurodevelopment conditions and how we can help in Heredia, Costa Rica.",
      pageHeader: {
        title: "Child Development Conditions",
        subtitle: "Information for parents about neurodevelopment conditions and how we can help"
      },
      seo: {
        title: "Child Development Conditions",
        description: "Information for parents about child neurodevelopment conditions in Heredia, Costa Rica. ADHD, ASD, high intellectual abilities, dyslexia, dyscalculia, nonverbal learning disorder and more. Experts in diagnosis and early intervention.",
        keywords: "child development conditions, neurodevelopment conditions, ADHD, ASD, high intellectual abilities, dyslexia, dyscalculia, nonverbal learning disorder, rare diseases, Costa Rica, Heredia, child diagnosis, early intervention"
      },
      introSection: {
        title: "About Development Conditions",
        description1: "In this section you will find information about the different child neurodevelopment conditions that we address at Neuro Peques. Our goal is to guide parents and caregivers about the main characteristics of these conditions, warning signs and possible therapeutic approaches.",
        description2: "It is important to understand that each child is unique, regardless of their diagnosis. The manifestations of these conditions vary enormously from one child to another, and our approach always adapts to the individual needs and specific strengths of each child.",
        teamInfo: "At Neuro Peques we have a specialized multidisciplinary team that works together to provide a comprehensive evaluation and personalized approach for each child and their family."
      },
      conditionsSection: {
        title: "Conditions We Treat",
        subtitle: "Learn more about the different neurodevelopment conditions that we evaluate and address in our clinic"
      },
      commonSigns: "Common signs to observe:",
      howWeHelp: "How can Neuro Peques help?",
      viewRelatedServices: "View related services",
      finalCta: {
        title: "Do you suspect your child might have any of these conditions?",
        description: "Early evaluation and proper diagnosis are fundamental to begin intervention. Contact us to schedule an initial consultation.",
        buttonText: "Request Evaluation"
      },
      conditions: {
        autism: {
          title: "Autism Spectrum Disorder (ASD)",
          description: "Autism Spectrum Disorder (ASD) is a complex neurological condition that affects communication, social interaction and may include restrictive or repetitive patterns of behavior and interests. The term 'spectrum' reflects the wide variety of strengths and challenges that people with ASD may experience, from exceptional skills in specific areas to significant difficulties in daily life.",
          signs: [
            "Difficulties in verbal and non-verbal communication (from absence of speech to subtleties in language comprehension)",
            "Challenges in social interaction and establishing or maintaining relationships with other children",
            "Restricted interests or repetitive behaviors that may be unusual in intensity or focus",
            "Unusual reactions to sensory stimuli (hypersensitivity or hyposensitivity to sounds, lights, textures)",
            "Preference for established routines and possible resistance to changes",
            "Possible presence of exceptional skills in specific areas (memory, music, mathematics, etc.)"
          ],
          help: "Our ASD specialized team offers detailed evaluations for early diagnosis of autism in children from 18 months. We develop personalized intervention plans based on scientific evidence that include therapies to improve social, communicative and self-regulation skills. We work with a child-centered approach, actively involving the family and providing practical strategies to implement in all of the child's environments.",
          imageAlt: "Child with autism in therapeutic session"
        },
        adhd: {
          title: "Attention Deficit Hyperactivity Disorder (ADHD)",
          description: "ADHD is a neurobiological condition that affects attentional regulation capacity, impulse control and activity level. It is considered one of the most common neurobehavioral conditions in childhood, affecting approximately 5-7% of school-age children. ADHD has an important genetic basis and affects the functioning of certain brain areas and neurotransmitters related to attention and self-control.",
          signs: [
            "Persistent difficulty maintaining attention on school tasks, conversations or play activities",
            "Seems not to listen when spoken to directly, even in the absence of obvious distractions",
            "Easily distracted by external stimuli or unrelated thoughts",
            "Difficulty organizing tasks and activities, and frequent loss of necessary objects",
            "In some cases, excessive motor restlessness, difficulty remaining seated or waiting for turn",
            "Possible impulsivity manifested in interruptions or hasty decisions"
          ],
          help: "At Neuro Peques we offer a comprehensive ADHD evaluation that covers multiple contexts (home, school) and includes specific neuropsychological tests. Our multimodal approach combines behavioral interventions, executive function training (organization, planning, self-regulation), personalized academic support and family guidance. We provide concrete strategies to improve school performance, social skills and self-esteem, working in coordination with the school.",
          imageAlt: "Child with ADHD in attention therapy session"
        },
        dyslexia: {
          title: "Dyslexia and Specific Learning Disorders",
          description: "Dyslexia is a specific learning disorder of neurobiological origin that mainly affects phonological processing and literacy acquisition. It is characterized by difficulties in accurate and fluent word recognition, decoding and spelling problems, despite normal intelligence and adequate educational opportunities. Other specific learning disorders include dysgraphia (difficulties in written expression) and dyscalculia (difficulties with mathematical concepts and procedures).",
          signs: [
            "Difficulty learning the relationship between letters and sounds (phonological awareness)",
            "Slow, effortful and low fluency reading, with frequent accuracy errors",
            "Persistent difficulties in spelling and written expression",
            "Possible problems in mathematics, especially in memorizing basic operations",
            "Avoidance of activities related to reading or writing",
            "Frequently, good verbal reasoning skills and oral comprehension"
          ],
          help: "We perform specialized evaluations in learning disorders to identify each child's unique profile of strengths and weaknesses. Our therapeutic approach includes structured and systematic programs based on evidence-based methodologies, such as multisensory strategies and phonological awareness training. We provide detailed and specific recommendations for adaptations in the school environment and support at home, focusing on developing compensatory strategies and enhancing the child's areas of strength.",
          imageAlt: "Girl with dyslexia receiving reading support"
        },
        intellectualDisability: {
          title: "Intellectual Disability",
          description: "Intellectual disability is a condition characterized by significant limitations in both intellectual functioning (reasoning, learning, problem solving) and adaptive behavior, which encompasses social and practical daily skills. This condition originates before the age of 18 and can vary in severity from mild to profound. It is important to note that, with adequate support, people with intellectual disabilities can develop numerous skills and enjoy a full life.",
          signs: [
            "Delay in developmental milestones (sitting, walking, talking)",
            "More significant learning difficulties than expected for age",
            "Limitations in conceptual skills such as reading, writing, mathematics, time, money",
            "Challenges in social skills such as understanding social rules, peer interaction and communication",
            "Difficulties in activities of daily living and personal autonomy",
            "Need for more time and repetition to learn new skills"
          ],
          help: "We offer a comprehensive evaluation of cognitive, adaptive and developmental functioning that allows determining the presence of intellectual disability and its level of severity. Our intervention approach focuses on developing each child's maximum potential, setting realistic but ambitious goals. We work on developing functional skills for daily living, effective communication, social integration and pre-vocational skills according to age. We provide detailed guidance to families and schools about adaptations, supports and available community resources.",
          imageAlt: "Child with intellectual disability in therapy session"
        },
        prematurity: {
          title: "Prematurity and Development",
          description: "Prematurity (birth before 37 weeks of gestation) can affect various aspects of child development due to the immaturity of organs and systems, particularly the central nervous system. Premature babies, especially those with very low birth weight or born before 32 weeks, may be at higher risk of complications or delays in their neurological, sensory, motor, cognitive, language and socioemotional development.",
          signs: [
            "Possible delays in acquiring motor milestones (holding head up, sitting, crawling, walking)",
            "Slower development of expressive and receptive language",
            "Greater sensitivity to sensory stimuli (noises, lights, textures)",
            "Possible difficulties in regulation (feeding, sleep, crying, consolability)",
            "Higher risk of attention, learning or behavior problems at school age",
            "In some cases, particularly in extreme prematurity, higher incidence of conditions such as cerebral palsy, visual or hearing disorders"
          ],
          help: "Our team offers neurodevelopment follow-up programs specifically designed for premature babies and children. We perform early and periodic evaluations to identify any warning signs or delays in development. We offer early intervention to enhance motor, cognitive, language and socioemotional development, adapting therapies to the child's corrected age. We provide specific guidance to parents on how to appropriately stimulate their premature child, respecting their rhythms and particular needs.",
          imageAlt: "Premature baby receiving early stimulation therapy"
        },
        rareDiseases: {
          title: "Rare Diseases with Neurodevelopment Involvement",
          description: "Rare diseases are conditions that affect a small proportion of the population (less than 5 per 10,000 people). Many rare diseases are of genetic origin and can affect child neurological development. These conditions can present diverse neurological, cognitive, behavioral or physical symptoms, and frequently require specialized multidisciplinary approach for their management.",
          signs: [
            "Unusual combination of symptoms or characteristics that do not correspond to common conditions",
            "Significant delays or atypical patterns in motor, language, cognitive or social development",
            "Regression or loss of previously acquired skills",
            "Distinctive physical characteristics or visible alterations in body structure",
            "Family history of genetic conditions or similar disorders",
            "Frequent hospitalizations or recurrent medical complications"
          ],
          help: "Our team collaborates closely with medical specialists in addressing rare diseases that affect neurodevelopment. We offer specialized neuropsychological evaluations to determine specific strengths and needs, even in complex clinical profiles. We develop personalized intervention programs focused on maximizing each child's potential and improving their quality of life. We provide detailed guidance to families about resources, technical aids, and management strategies, and facilitate connection with patient associations and community resources specific to rare diseases.",
          imageAlt: "Child with rare disease in therapeutic session"
        }
      }
    },
    ourTests: {
      seo: {
        title: {
          es: "Nuestras Pruebas",
          en: "Our Tests"
        },
        description: {
          es: "Evaluaciones neuropsicológicas validadas científicamente para un diagnóstico preciso en Heredia, Costa Rica. Pruebas estandarizadas para TDAH, TEA, altas capacidades y condiciones del desarrollo.",
          en: "Scientifically validated neuropsychological assessments for accurate diagnosis in Heredia, Costa Rica. Standardized tests for ADHD, ASD, high abilities and development conditions."
        },
        keywords: {
          es: "pruebas neuropsicológicas, evaluación infantil, diagnóstico TDAH, diagnóstico TEA, altas capacidades, pruebas estandarizadas, Costa Rica, Heredia, evaluación neurodesarrollo",
          en: "neuropsychological tests, child evaluation, ADHD diagnosis, ASD diagnosis, high abilities, standardized tests, Costa Rica, Heredia, neurodevelopment evaluation"
        }
      },
      pageHeader: {
        title: {
          es: "Nuestras Pruebas",
          en: "Our Tests"
        },
        subtitle: {
          es: "Evaluaciones neuropsicológicas validadas científicamente para un diagnóstico preciso",
          en: "Scientifically validated neuropsychological assessments for accurate diagnosis"
        }
      },
      introSection: {
        title: {
          es: "Evaluación con Fundamentos Científicos",
          en: "Assessment with Scientific Foundations"
        },
        description1: {
          es: "En Neuro Peques utilizamos pruebas con estándares internacionales, estandarizadas y validadas científicamente mediante rigurosos procesos de investigación, que nos permiten realizar una evaluación neuropsicológica completa, precisa y con máxima objetividad diagnóstica.",
          en: "At Neuro Peques we use tests with international standards, standardized and scientifically validated through rigorous research processes, which allow us to perform a complete, accurate neuropsychological assessment with maximum diagnostic objectivity."
        },
        description2: {
          es: "Nuestro protocolo de evaluación se adapta a las necesidades específicas de cada niño, seleccionando las pruebas más adecuadas según su edad, desarrollo y motivo de consulta. Esto nos permite obtener información valiosa para el diagnóstico y establecer un plan de intervención personalizado.",
          en: "Our assessment protocol adapts to the specific needs of each child, selecting the most appropriate tests according to their age, development and reason for consultation. This allows us to obtain valuable information for diagnosis and establish a personalized intervention plan."
        }
      },
      testCategories: {
        cognitive: {
          title: {
            es: "Evaluación Cognitiva General",
            en: "General Cognitive Assessment"
          },
          description: {
            es: "Estas pruebas evalúan las habilidades cognitivas generales, incluyendo inteligencia, memoria, atención y funciones ejecutivas.",
            en: "These tests evaluate general cognitive abilities, including intelligence, memory, attention and executive functions."
          }
        },
        attention: {
          title: {
            es: "Atención y TDAH",
            en: "Attention and ADHD"
          },
          description: {
            es: "Pruebas específicas para evaluar la atención sostenida, selectiva y dividida, así como el control inhibitorio.",
            en: "Specific tests to evaluate sustained, selective and divided attention, as well as inhibitory control."
          }
        },
        learning: {
          title: {
            es: "Trastornos del Aprendizaje",
            en: "Learning Disorders"
          },
          description: {
            es: "Pruebas diseñadas para detectar dificultades específicas en lectura, escritura y cálculo matemático.",
            en: "Tests designed to detect specific difficulties in reading, writing and mathematical calculation."
          }
        },
        social: {
          title: {
            es: "Desarrollo Social y Emocional",
            en: "Social and Emotional Development"
          },
          description: {
            es: "Evaluaciones para valorar el desarrollo de habilidades sociales, reconocimiento emocional y teoría de la mente.",
            en: "Assessments to evaluate the development of social skills, emotional recognition and theory of mind."
          }
        }
      },
      processSection: {
        title: {
          es: "Proceso de Evaluación",
          en: "Assessment Process"
        },
        subtitle: {
          es: "Nuestro abordaje paso a paso para una evaluación integral",
          en: "Our step-by-step approach for a comprehensive assessment"
        },
        steps: {
          step1: {
            title: {
              es: "Entrevista Inicial",
              en: "Initial Interview"
            },
            description: {
              es: "Reunión con los padres para recopilar información sobre el desarrollo, historia médica, desempeño académico y comportamiento del niño.",
              en: "Meeting with parents to gather information about development, medical history, academic performance and child behavior."
            }
          },
          step2: {
            title: {
              es: "Selección de Pruebas",
              en: "Test Selection"
            },
            description: {
              es: "Diseño de un protocolo de evaluación personalizado según las necesidades específicas, la edad y el motivo de consulta.",
              en: "Design of a personalized assessment protocol according to specific needs, age and reason for consultation."
            }
          },
          step3: {
            title: {
              es: "Aplicación de Pruebas",
              en: "Test Administration"
            },
            description: {
              es: "Sesiones de evaluación en un ambiente confortable donde se aplican las pruebas seleccionadas. Pueden ser necesarias 2-3 sesiones dependiendo de la complejidad.",
              en: "Assessment sessions in a comfortable environment where selected tests are administered. 2-3 sessions may be necessary depending on complexity."
            }
          },
          step4: {
            title: {
              es: "Informe y Devolución",
              en: "Report and Feedback"
            },
            description: {
              es: "Elaboración de un informe completo con resultados, diagnóstico y recomendaciones. Reunión con los padres para explicar los hallazgos y el plan de intervención.",
              en: "Preparation of a complete report with results, diagnosis and recommendations. Meeting with parents to explain findings and intervention plan."
            }
          }
        }
      },
      finalCta: {
        title: {
          es: "¿Necesitas una evaluación para tu hijo?",
          en: "Do you need an assessment for your child?"
        },
        description: {
          es: "En Neuro Peques estamos listos para ayudarte. Contáctanos para agendar una evaluación inicial.",
          en: "At Neuro Peques we are ready to help you. Contact us to schedule an initial assessment."
        },
        buttonText: {
          es: "Agenda una Evaluación",
          en: "Schedule an Assessment"
        }
      }
    },
    developmentConditions: {
      seo: {
        title: {
          es: "Condiciones del Desarrollo",
          en: "Development Conditions"
        },
        description: {
          es: "Información detallada sobre condiciones del neurodesarrollo y su intervención en Heredia, Costa Rica. Expertos en evaluación e intervención temprana para TDAH, TEA, altas capacidades y más.",
          en: "Detailed information about neurodevelopment conditions and their intervention in Heredia, Costa Rica. Experts in early evaluation and intervention for ADHD, ASD, high abilities and more."
        },
        keywords: {
          es: "condiciones desarrollo, condiciones neurodesarrollo, intervención temprana, evaluación desarrollo, TDAH, TEA, altas capacidades, trastorno aprendizaje no verbal, Costa Rica, Heredia, neuropsicología infantil",
          en: "development conditions, neurodevelopment conditions, early intervention, development evaluation, ADHD, ASD, high abilities, nonverbal learning disorder, Costa Rica, Heredia, child neuropsychology"
        }
      },
      pageHeader: {
        title: {
          es: "Condiciones del Desarrollo",
          en: "Development Conditions"
        },
        subtitle: {
          es: "Información detallada sobre condiciones del neurodesarrollo y su intervención",
          en: "Detailed information about neurodevelopment conditions and their intervention"
        }
      },
      introSection: {
        title: {
          es: "Comprensión Profunda para Mejor Intervención",
          en: "Deep Understanding for Better Intervention"
        },
        description1: {
          es: "Cada condición del desarrollo tiene características únicas que requieren un enfoque especializado y personalizado. En Neuro Peques, nos dedicamos a comprender profundamente cada trastorno para brindar la mejor atención posible, mediante un enfoque integral y basado en evidencia científica.",
          en: "Each development condition has unique characteristics that require a specialized and personalized approach. At Neuro Peques, we are dedicated to deeply understanding each disorder to provide the best possible care through a comprehensive approach based on scientific evidence."
        }
      },
      categories: {
        neurodevelopment: {
          title: {
            es: "Trastornos del Neurodesarrollo",
            en: "Neurodevelopment Disorders"
          },
          description: {
            es: "Condiciones que afectan el desarrollo del sistema nervioso y el cerebro",
            en: "Conditions that affect the development of the nervous system and brain"
          },
          conditions: {
            autism: {
              name: {
                es: "Trastorno del Espectro Autista (TEA)",
                en: "Autism Spectrum Disorder (ASD)"
              },
              description: {
                es: "Condición del desarrollo que afecta la comunicación, interacción social y comportamiento",
                en: "Developmental condition that affects communication, social interaction and behavior"
              },
              symptoms: {
                es: ["Dificultades en comunicación social", "Patrones repetitivos de comportamiento", "Intereses restringidos"],
                en: ["Difficulties in social communication", "Repetitive behavior patterns", "Restricted interests"]
              },
              age: {
                es: "Desde los primeros meses hasta los 3 años",
                en: "From the first months to 3 years"
              }
            },
            adhd: {
              name: {
                es: "TDAH",
                en: "ADHD"
              },
              description: {
                es: "Trastorno caracterizado por dificultades de atención, hiperactividad e impulsividad",
                en: "Disorder characterized by attention difficulties, hyperactivity and impulsivity"
              },
              symptoms: {
                es: ["Dificultad para mantener la atención", "Hiperactividad excesiva", "Impulsividad"],
                en: ["Difficulty maintaining attention", "Excessive hyperactivity", "Impulsivity"]
              },
              age: {
                es: "Generalmente identificado en edad escolar",
                en: "Generally identified at school age"
              }
            },
            intellectualDisability: {
              name: {
                es: "Discapacidad Intelectual",
                en: "Intellectual Disability"
              },
              description: {
                es: "Limitaciones en el funcionamiento intelectual y en la conducta adaptativa",
                en: "Limitations in intellectual functioning and adaptive behavior"
              },
              symptoms: {
                es: ["Dificultades de aprendizaje", "Problemas de adaptación", "Limitaciones en habilidades sociales"],
                en: ["Learning difficulties", "Adaptation problems", "Limitations in social skills"]
              },
              age: {
                es: "Puede identificarse desde la primera infancia",
                en: "Can be identified from early childhood"
              }
            }
          }
        },
        learning: {
          title: {
            es: "Trastornos del Aprendizaje",
            en: "Learning Disorders"
          },
          description: {
            es: "Dificultades específicas en áreas académicas",
            en: "Specific difficulties in academic areas"
          },
          conditions: {
            dyslexia: {
              name: {
                es: "Dislexia",
                en: "Dyslexia"
              },
              description: {
                es: "Dificultad específica en la lectura y escritura",
                en: "Specific difficulty in reading and writing"
              },
              symptoms: {
                es: ["Dificultad para leer", "Problemas de ortografía", "Confusión de letras"],
                en: ["Difficulty reading", "Spelling problems", "Letter confusion"]
              },
              age: {
                es: "Identificable desde los 6-7 años",
                en: "Identifiable from 6-7 years"
              }
            },
            dyscalculia: {
              name: {
                es: "Discalculia",
                en: "Dyscalculia"
              },
              description: {
                es: "Dificultad específica en el procesamiento matemático",
                en: "Specific difficulty in mathematical processing"
              },
              symptoms: {
                es: ["Problemas con números", "Dificultad para contar", "Confusión con operaciones"],
                en: ["Problems with numbers", "Difficulty counting", "Confusion with operations"]
              },
              age: {
                es: "Identificable desde los 6-7 años",
                en: "Identifiable from 6-7 years"
              }
            },
            dysgraphia: {
              name: {
                es: "Disgrafía",
                en: "Dysgraphia"
              },
              description: {
                es: "Dificultad específica en la escritura",
                en: "Specific difficulty in writing"
              },
              symptoms: {
                es: ["Escritura ilegible", "Problemas de ortografía", "Dificultad para organizar ideas"],
                en: ["Illegible writing", "Spelling problems", "Difficulty organizing ideas"]
              },
              age: {
                es: "Identificable desde los 6-7 años",
                en: "Identifiable from 6-7 years"
              }
            }
          }
        },
        motor: {
          title: {
            es: "Trastornos Motores",
            en: "Motor Disorders"
          },
          description: {
            es: "Condiciones que afectan el movimiento y la coordinación",
            en: "Conditions that affect movement and coordination"
          },
          conditions: {
            coordination: {
              name: {
                es: "Trastorno del Desarrollo de la Coordinación",
                en: "Developmental Coordination Disorder"
              },
              description: {
                es: "Dificultades en la coordinación motora que interfieren con las actividades diarias",
                en: "Difficulties in motor coordination that interfere with daily activities"
              },
              symptoms: {
                es: ["Torpeza motora", "Dificultad para vestirse", "Problemas de equilibrio"],
                en: ["Motor clumsiness", "Difficulty dressing", "Balance problems"]
              },
              age: {
                es: "Identificable desde los 5-6 años",
                en: "Identifiable from 5-6 years"
              }
            },
            tics: {
              name: {
                es: "Trastornos de Tics",
                en: "Tic Disorders"
              },
              description: {
                es: "Movimientos o sonidos involuntarios, repetitivos y estereotipados",
                en: "Involuntary, repetitive and stereotyped movements or sounds"
              },
              symptoms: {
                es: ["Tics motores", "Tics vocales", "Movimientos repetitivos"],
                en: ["Motor tics", "Vocal tics", "Repetitive movements"]
              },
              age: {
                es: "Generalmente aparece entre los 4-6 años",
                en: "Generally appears between 4-6 years"
              }
            }
          }
        },
        behavior: {
          title: {
            es: "Trastornos del Comportamiento",
            en: "Behavior Disorders"
          },
          description: {
            es: "Dificultades en la regulación conductual y emocional",
            en: "Difficulties in behavioral and emotional regulation"
          },
          conditions: {
            oppositional: {
              name: {
                es: "Trastorno Negativista Desafiante",
                en: "Oppositional Defiant Disorder"
              },
              description: {
                es: "Patrón de comportamiento negativista, hostil y desafiante",
                en: "Pattern of negativistic, hostile and defiant behavior"
              },
              symptoms: {
                es: ["Oposición a las reglas", "Irritabilidad frecuente", "Venganza"],
                en: ["Opposition to rules", "Frequent irritability", "Vengeance"]
              },
              age: {
                es: "Generalmente aparece antes de los 8 años",
                en: "Generally appears before 8 years"
              }
            },
            conduct: {
              name: {
                es: "Trastorno de Conducta",
                en: "Conduct Disorder"
              },
              description: {
                es: "Patrón repetitivo y persistente de comportamiento que viola los derechos de otros",
                en: "Repetitive and persistent pattern of behavior that violates the rights of others"
              },
              symptoms: {
                es: ["Agresión hacia personas o animales", "Destrucción de propiedad", "Engaño o robo"],
                en: ["Aggression toward people or animals", "Destruction of property", "Deceit or theft"]
              },
              age: {
                es: "Puede aparecer desde la infancia temprana",
                en: "Can appear from early childhood"
              }
            }
          }
        }
      },
      commonElements: {
        mainSymptoms: {
          es: "Síntomas Principales:",
          en: "Main Symptoms:"
        },
        identificationAge: {
          es: "Edad de Identificación:",
          en: "Identification Age:"
        },
        consultSpecialist: {
          es: "Consultar Especialista",
          en: "Consult Specialist"
        }
      },
      earlyIntervention: {
        title: {
          es: "¿Por Qué la Intervención Temprana es Crucial?",
          en: "Why is Early Intervention Crucial?"
        },
        description: {
          es: "La intervención temprana puede cambiar significativamente el curso del desarrollo de un niño. Cuanto antes se identifique y se intervenga, mejores serán los resultados a largo plazo.",
          en: "Early intervention can significantly change the course of a child's development. The earlier it is identified and intervened, the better the long-term results will be."
        },
        benefits: {
          brainPlasticity: {
            title: {
              es: "Plasticidad Cerebral",
              en: "Brain Plasticity"
            },
            description: {
              es: "El cerebro infantil tiene mayor capacidad de adaptación",
              en: "The child's brain has greater adaptation capacity"
            }
          },
          prevention: {
            title: {
              es: "Prevención Secundaria",
              en: "Secondary Prevention"
            },
            description: {
              es: "Evita el desarrollo de problemas adicionales",
              en: "Prevents the development of additional problems"
            }
          },
          familySupport: {
            title: {
              es: "Apoyo Familiar",
              en: "Family Support"
            },
            description: {
              es: "Orienta a los padres desde el inicio",
              en: "Guides parents from the beginning"
            }
          }
        }
      },
      importantNote: {
        title: {
          es: "Nota Importante",
          en: "Important Note"
        },
        description1: {
          es: "La información proporcionada en esta página es solo informativa y no debe utilizarse para autodiagnóstico. Cada niño es único y puede presentar síntomas diferentes.",
          en: "The information provided on this page is for informational purposes only and should not be used for self-diagnosis. Each child is unique and may present different symptoms."
        },
        description2: {
          es: "Si tienes preocupaciones sobre el desarrollo de tu hijo, es fundamental consultar con un especialista calificado para una evaluación profesional completa.",
          en: "If you have concerns about your child's development, it is essential to consult with a qualified specialist for a complete professional evaluation."
        }
      },
      finalCta: {
        title: {
          es: "¿Necesitas una Evaluación Profesional?",
          en: "Do You Need a Professional Evaluation?"
        },
        description: {
          es: "No esperes. La detección temprana puede hacer una gran diferencia en el desarrollo de tu hijo. Contáctanos para una evaluación integral y personalizada.",
          en: "Don't wait. Early detection can make a big difference in your child's development. Contact us for a comprehensive and personalized evaluation."
        },
        buttons: {
          scheduleEvaluation: {
            es: "Agendar Evaluación",
            en: "Schedule Evaluation"
          },
          viewServices: {
            es: "Ver Nuestros Servicios",
            en: "View Our Services"
          }
        }
      }
    },
    errorPages: {
      notFound: {
        title: "Page not found",
        message: "Sorry, the page you're looking for doesn't exist or has been moved.",
        suggestions: {
          services: {
            title: "Were you looking for our services?",
            items: [
              "Child Neuropsychology",
              "Child Psychology",
              "Psychopedagogy",
              "Speech Therapy",
              "Occupational Therapy",
              "General Child Medicine"
            ]
          }
        }
      },
      generic: {
        title: "Unexpected error",
        message: "An unexpected error has occurred. Please try again."
      }
    }
  }
};

export type Locale = keyof typeof dictionary;
export type Dictionary = typeof dictionary.es;
